import React from "react";

import "./styles.scss";

/** Admin'in yüklediği banner görseli (ana sayfa slider'ı ve Yarışmalar listesi). */
const CompetitionBanner = ({ competition }) => (
  <div className="cmp-banner">
    <img src={competition.bannerImageUrl} alt={competition.name} />
  </div>
);

export default CompetitionBanner;
